import styled from 'styled-components'
import { media } from '../../Styles/media'

const Content = styled.main`
  padding: 0 2em;

  header {
    display: flex;
    flex-direction: column;
    justify-content: center;

    width: 100%;
    ${media.desktop`
      align-items: center;
    `}
  }
`

export { Content }



// WEBPACK FOOTER //
// ./src/Components/Main/styles.js